import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";

const LINKS = [
    { key: "planos", label: "Planos", path: "../Planos" },
    { key: "solucoes", label: "Soluções", path: "../Solucoes" },
    { key: "nichos", label: "Nichos", path: "../Nichos" },
    { key: "sobreNos", label: "Sobre nós", path: "../SobreNos" },
];

function Header(props) {
    const token = localStorage.getItem("token");
    const navigate = useNavigate();
    const isDashboard = props.active === "dashboard";

    const [showHeader, setShowHeader] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollY && currentScrollY > 50) {
                setShowHeader(false);
                setMenuOpen(false);
            } else {
                setShowHeader(true);
            }
            setScrolled(currentScrollY > 10);
            setLastScrollY(currentScrollY);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY]);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    const go = (path) => {
        setMenuOpen(false);
        navigate(path);
    };

    return (
        <header
            className={`hdr ${scrolled ? "hdr--scrolled" : ""}`}
            style={{ top: showHeader ? "0" : "-85px" }}
        >
            <div className="hdr-inner">
                {/* Logo */}
                <div className="hdr-logo" onClick={() => go("../")}>
                    <img src="/assets/logoClarea01.png" alt="Clarea Vital" />
                </div>

                {/* Menu mobile toggle (no dashboard logado o menu fica vazio, então não exibe) */}
                {!(isDashboard && token) && (
                    <button
                        type="button"
                        className={`hdr-toggle ${menuOpen ? "is-open" : ""}`}
                        onClick={toggleMenu}
                        aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
                        aria-expanded={menuOpen}
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                )}

                {/* Menu */}
                <nav className={`hdr-menu ${menuOpen ? "open" : "closed"}`}>
                    {!isDashboard && (
                        <div className="hdr-links">
                            {LINKS.map((link) => (
                                <span
                                    key={link.key}
                                    className={`hdr-link ${props.active === link.key ? "is-active" : ""}`}
                                    onClick={() => go(link.path)}
                                >
                                    {link.label}
                                </span>
                            ))}
                            <a
                                href={gerarLinkWhatsApp("Olá, tenho uma dúvida sobre os planos!")}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`hdr-link ${props.active === "duvidas" ? "is-active" : ""}`}
                                onClick={() => setMenuOpen(false)}
                            >
                                <WhatsAppIcon sx={{ fontSize: 16 }} />
                                Dúvidas
                            </a>
                        </div>
                    )}

                    <div className="hdr-actions">
                        {!token && (
                            <>
                                <button type="button" className="hdr-btn hdr-btn--ghost" onClick={() => go("../Login")}>
                                    <PersonOutlineIcon sx={{ fontSize: 18 }} />
                                    Entrar
                                </button>
                                {!isDashboard && (
                                    <button type="button" className="hdr-btn hdr-btn--primary" onClick={() => go("../Planos")}>
                                        Assinar agora
                                    </button>
                                )}
                            </>
                        )}
                        {token && !isDashboard && (
                            <button type="button" className="hdr-btn hdr-btn--primary" onClick={() => go("../Dashboard")}>
                                <AccountCircleIcon sx={{ fontSize: 18 }} />
                                Minha conta
                            </button>
                        )}
                    </div>
                </nav>
            </div>

            {/* CSS inline para hover e responsivo */}
            <style>
                {`
                .hdr {
                    position: fixed;
                    left: 0;
                    width: 100%;
                    height: 80px;
                    z-index: 1000;
                    display: flex;
                    justify-content: center;
                    background-color: #0b243d;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
                    transition: top 0.3s ease-in-out, background-color 0.3s ease, box-shadow 0.3s ease;
                }
                .hdr--scrolled {
                    background-color: rgba(11, 36, 61, 0.92);
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
                }
                .hdr-inner {
                    width: 90%;
                    max-width: 1280px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 24px;
                    color: #fff;
                }
                .hdr-logo {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    flex-shrink: 0;
                }
                .hdr-logo img {
                    height: 46px;
                    display: block;
                }

                .hdr-menu {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    gap: 32px;
                }
                .hdr-links {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }
                .hdr-link {
                    position: relative;
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    padding: 8px 14px;
                    border-radius: 8px;
                    color: rgba(255, 255, 255, 0.82);
                    font-size: 0.92rem;
                    font-weight: 500;
                    letter-spacing: 0.2px;
                    text-decoration: none;
                    cursor: pointer;
                    transition: color 0.2s ease, background-color 0.2s ease;
                }
                .hdr-link:hover {
                    color: #fff;
                    background-color: rgba(255, 255, 255, 0.06);
                }
                .hdr-link::after {
                    content: "";
                    position: absolute;
                    left: 14px;
                    right: 14px;
                    bottom: 2px;
                    height: 2px;
                    border-radius: 2px;
                    background-color: #ffc845;
                    transform: scaleX(0);
                    transition: transform 0.25s ease;
                }
                .hdr-link.is-active {
                    color: #ffc845;
                    font-weight: 600;
                }
                .hdr-link.is-active::after,
                .hdr-link:hover::after {
                    transform: scaleX(1);
                }

                .hdr-actions {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
                .hdr-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    height: 40px;
                    padding: 0 18px;
                    border-radius: 10px;
                    font-family: inherit;
                    font-size: 0.9rem;
                    font-weight: 600;
                    cursor: pointer;
                    white-space: nowrap;
                    transition: all 0.2s ease;
                }
                .hdr-btn--ghost {
                    color: #fff;
                    background: transparent;
                    border: 1px solid rgba(255, 255, 255, 0.28);
                }
                .hdr-btn--ghost:hover {
                    border-color: #fff;
                    background-color: rgba(255, 255, 255, 0.06);
                }
                .hdr-btn--primary {
                    color: #0b243d;
                    background-color: #ffc845;
                    border: 1px solid #ffc845;
                    font-weight: 700;
                    box-shadow: 0 4px 14px rgba(255, 200, 69, 0.3);
                }
                .hdr-btn--primary:hover {
                    background-color: #e9b53d;
                    border-color: #e9b53d;
                    transform: translateY(-1px);
                    box-shadow: 0 6px 18px rgba(255, 200, 69, 0.4);
                }

                .hdr-toggle {
                    display: none;
                    width: 42px;
                    height: 42px;
                    padding: 0;
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    border-radius: 10px;
                    background: transparent;
                    cursor: pointer;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                }
                .hdr-toggle span {
                    width: 20px;
                    height: 2px;
                    border-radius: 2px;
                    background-color: #ffc845;
                    transition: transform 0.3s ease, opacity 0.2s ease;
                }
                .hdr-toggle.is-open span:nth-child(1) {
                    transform: translateY(7px) rotate(45deg);
                }
                .hdr-toggle.is-open span:nth-child(2) {
                    opacity: 0;
                }
                .hdr-toggle.is-open span:nth-child(3) {
                    transform: translateY(-7px) rotate(-45deg);
                }

                @media (max-width: 900px) {
                    .hdr-toggle {
                        display: flex;
                    }
                    .hdr-menu {
                        position: absolute;
                        top: 80px;
                        left: 0;
                        width: 100%;
                        box-sizing: border-box;
                        flex-direction: column;
                        align-items: stretch;
                        gap: 16px;
                        padding: 12px 5% 20px;
                        background-color: #0b243d;
                        border-top: 1px solid rgba(255, 255, 255, 0.08);
                        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
                    }
                    .hdr-menu.closed {
                        display: none;
                    }
                    .hdr-links {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 2px;
                    }
                    .hdr-link {
                        padding: 14px 12px;
                        font-size: 1rem;
                        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
                        border-radius: 0;
                    }
                    .hdr-link::after {
                        display: none;
                    }
                    .hdr-link.is-active {
                        border-left: 3px solid #ffc845;
                        background-color: rgba(255, 200, 69, 0.08);
                    }
                    .hdr-actions {
                        flex-direction: column;
                        align-items: stretch;
                    }
                    .hdr-btn {
                        height: 46px;
                        width: 100%;
                    }
                }
                `}
            </style>
        </header>
    );
}

export default Header;
